import { render, staticRenderFns } from "./ioRecordList.vue?vue&type=template&id=8a2e89fc&scoped=true"
import script from "./ioRecordList.vue?vue&type=script&lang=js"
export * from "./ioRecordList.vue?vue&type=script&lang=js"
import style0 from "./ioRecordList.vue?vue&type=style&index=0&id=8a2e89fc&prod&scoped=true&lang=css"
import style1 from "./ioRecordList.vue?vue&type=style&index=1&id=8a2e89fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2e89fc",
  null
  
)

export default component.exports